import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Configure20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.25 3.5C9.25 2.80964 9.80964 2.25 10.5 2.25H15C15.6904 2.25 16.25 2.80964 16.25 3.5V4.75H20V6.25H16.25V7.5C16.25 8.19036 15.6904 8.75 15 8.75H10.5C9.80964 8.75 9.25 8.19036 9.25 7.5V6.25H0V4.75H9.25V3.5ZM10.75 3.75V7.25H14.75V3.75H10.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 13.75L3.75 12.5C3.75 11.8096 4.30964 11.25 5 11.25L9.5 11.25C10.1904 11.25 10.75 11.8096 10.75 12.5V13.75L20 13.75V15.25L10.75 15.25V16.5C10.75 17.1904 10.1904 17.75 9.5 17.75L5 17.75C4.30964 17.75 3.75 17.1904 3.75 16.5L3.75 15.25H0V13.75H3.75ZM9.25 12.75V16.25L5.25 16.25L5.25 12.75L9.25 12.75Z'
      fill='currentColor'
    />
  </Svg>
);

Configure20.displayName = 'Configure20';
export default Configure20;
